export interface LinkProps {
  d: number;
  theta: number;
  a: number;
  alpha: number;
  type: string;
  hideAxis?: boolean;
}

export function isLinkProps(obj: any): obj is LinkProps {
  return (
    obj &&
    typeof obj.d === "number" &&
    typeof obj.theta === "number" &&
    typeof obj.a === "number" &&
    typeof obj.alpha === "number" &&
    typeof obj.type === "string"
  );
}
